<template>
	<vs-popup :title="$t('StoreHosueId')" v-if="!isMobile()" button-cancel="border" @cancel="clearFields"
		@close="clearFields" :active.sync="isSidebarActiveLocal" classContent="popup-example" fullscreen>
		<div>
			<b-row>
				<b-col cols="4">
					<vs-card>
						<div>
							<form>

								<div class="vx-row">
									<div class="vx-col w-full">
										<b-tabs content-class="mt-3" v-model="tabIndex" class="vs-input--label">

											<b-tab :title="$t('General')" active>
												<component :is="scrollbarTag" ref="scroll" class="scroll-area--data-list-add-new "
													:settings="settings" :key="$vs.rtl">
													<div class="pr-6 pt-6">
														<b-row>
															<b-col cols="4" align-self="center">
																<b-form-group :label="'* ' + $t('StoreHosueNo') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" v-model="storeHosueNo" name="storeHosueNo"
																	v-validate="'required'" />
																<span class="text-danger text-sm" v-show="errors.has('storeHosueNo')">{{
																	errors.first('storeHosueNo')
																}}</span>
															</b-col>
														</b-row>


														<b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="'* ' + $t('StoreHosueName') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" v-model="storehosueName" name="storehosueName"
																	v-validate="'required'" />
																<span class="text-danger text-sm" v-show="errors.has('storehosueName')">{{
																	errors.first('storehosueName')
																}}</span>
															</b-col>
														</b-row>
														<b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('GroupCode') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" v-model="groupCode" name="stock_name" />
															</b-col>
														</b-row>
														<b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('SpecCode1') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" v-model="specCode1" name="stock_name" />
															</b-col>
														</b-row>
														<b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('SpecCode2') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" v-model="specCode2" name="stock_name" />
															</b-col>
														</b-row>
														<b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('Description') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<vs-textarea v-model="description" />
															</b-col>

														</b-row>
														<b-row>
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('Note') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<vs-textarea v-model="note" />
															</b-col>
														</b-row>
													</div>
												</component>
											</b-tab>
											<b-tab :title="$t('Detail')">
												<component :is="scrollbarTag" ref="scroll" class="scroll-area--data-list-add-new"
													:settings="settings" :key="$vs.rtl">
													<div class="pr-6 pt-6">
														<b-row>
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('Preference') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" type="number" v-model="preference"
																	name="stock_name" />
															</b-col>
														</b-row>
														<b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('MyProperty') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" type="number" v-model="myProperty"
																	name="stock_name" />
															</b-col>
														</b-row>
														<b-row style="margin-top: 8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('Status') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<v-select color="danger" v-model="status" :options="status_choices" size="small"
																	label="text" autocomplete ref="selectElement" name="user_IsActive">
																</v-select>
															</b-col>
														</b-row>
														<b-row style="margin-top: 8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('CancelDate') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-datepicker id="baslangic" v-model="cancelDate" size="md" :locale="locale"
																	class="mb-2" today-variant="danger" placeholder="-" :start-weekday="weekday"
																	:date-format-options="{
																		year: 'numeric',
																		month: 'numeric',
																		day: 'numeric'
																	}" />
															</b-col>
														</b-row>
														<b-row>
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('Disdance') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" type="number" v-model="disdance"
																	name="stock_name" />
															</b-col>
														</b-row>
														<b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('Floor') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" v-model="floor" name="stock_name" />
															</b-col>
														</b-row><b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('Hall') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" v-model="hall" name="stock_name" />
															</b-col>
														</b-row>
													</div>
												</component>
											</b-tab>
										</b-tabs>
									</div>
								</div>
							</form>
						</div>


						<div class="items-center pl-6  mt-0 mb-0">
							<b-row align-h="end">
								<b-col cols="3" md="auto" style=" padding: 0px;">
									<b-button class="bg-danger" style=" border-color:white;" v-on:click="initValues">
										<Icon icon="material-symbols:cancel-outline" style="margin-right: 5px" width="20" height="20" />{{
											$t('Cancel') }}
									</b-button>
								</b-col>
								<b-col cols="3" md="auto">
									<b-button class="bg-primary" style=" border-color:white;" v-on:click="addStorehouseDetail()">
										<Icon icon="material-symbols:save-outline" style="margin-right: 5px" width="20" height="20" />{{
											$t('Save') }}
									</b-button>
								</b-col>

							</b-row>
						</div>
					</vs-card>
				</b-col>
				<b-col>
					<vs-card>
						<ag-grid-vue ref="agGridTable" class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
							:columnDefs="storehouseDetailColumns" :defaultColDef="defaultColDef" :rowData="storehouseDetailList"
							rowSelection="multiple" colResizeDefault="shift" :animateRows="true" :pagination="true"
							@grid-ready="onGridReady" :suppressCopyRowsToClipboard="true" :suppressPaginationPanel="true"
							:localeText="localeText">
						</ag-grid-vue>

					</vs-card>
				</b-col>
			</b-row>
		</div>
	</vs-popup>
	<vs-popup :title="$t('StoreHosueId')" v-else button-cancel="border" @cancel="clearFields" @close="clearFields"
		:active.sync="isSidebarActiveLocal" classContent="popup-example" fullscreen>
		<div>
			<b-row>
				<b-col cols="12">
					<vs-card>
						<div>
							<form>

								<div class="vx-row">
									<div class="vx-col w-full">
										<b-tabs content-class="mt-3" v-model="tabIndex" class="vs-input--label">
											<b-tab :title="$t('General')" active>
												<component :is="scrollbarTag" ref="scroll" class="scroll-area--data-list-add-new-mobile"
													:settings="settings" :key="$vs.rtl">
													<div class="pr-6">
														<b-row>
															<b-col cols="4" align-self="center">
																<b-form-group :label="'* ' + $t('StoreHosueNo') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" v-model="storeHosueNo" name="storeHosueNo"
																	v-validate="'required'" />
																<span class="text-danger text-sm" v-show="errors.has('storeHosueNo')">{{
																	errors.first('storeHosueNo')
																}}</span>
															</b-col>
														</b-row>
														<b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="'* ' + $t('StoreHosueName') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" v-model="storehosueName" name="storehosueName"
																	v-validate="'required'" />
																<span class="text-danger text-sm" v-show="errors.has('storehosueName')">{{
																	errors.first('storehosueName')
																}}</span>
															</b-col>
														</b-row>
														<b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('GroupCode') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" v-model="groupCode" name="stock_name" />
															</b-col>
														</b-row>
														<b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('SpecCode1') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" v-model="specCode1" name="stock_name" />
															</b-col>
														</b-row>
														<b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('SpecCode2') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" v-model="specCode2" name="stock_name" />
															</b-col>
														</b-row>
														<b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('Description') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<vs-textarea v-model="description" />
															</b-col>

														</b-row>
														<b-row>
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('Note') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<vs-textarea v-model="note" />
															</b-col>
														</b-row>

													</div>

												</component>
											</b-tab>
											<b-tab :title="$t('Detail')">
												<component :is="scrollbarTag" ref="scroll" class="scroll-area--data-list-add-new-mobile"
													:settings="settings" :key="$vs.rtl">
													<div class="pr-6">
														<b-row>
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('Preference') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" type="number" v-model="preference"
																	name="stock_name" />
															</b-col>
														</b-row>
														<b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('MyProperty') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" type="number" v-model="myProperty"
																	name="stock_name" />
															</b-col>
														</b-row>
														<b-row style="margin-top: 8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('Status') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<v-select color="danger" v-model="status" :options="status_choices" size="small"
																	label="text" autocomplete ref="selectElement" name="user_IsActive">
																</v-select>
															</b-col>
														</b-row>
														<b-row style="margin-top: 8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('CancelDate') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-datepicker id="baslangic" v-model="cancelDate" size="md" :locale="locale"
																	class="mb-2" today-variant="danger" placeholder="-" :start-weekday="weekday"
																	:date-format-options="{
																		year: 'numeric',
																		month: 'numeric',
																		day: 'numeric'
																	}" />
															</b-col>
														</b-row>
														<b-row>
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('Disdance') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" type="number" v-model="disdance"
																	name="stock_name" />
															</b-col>
														</b-row>
														<b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('Floor') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" v-model="floor" name="stock_name" />
															</b-col>
														</b-row><b-row style="margin-top:8px">
															<b-col cols="4" align-self="center">
																<b-form-group :label="$t('Hall') + ' :'" label-for="h-first-name" style="font-weight: 600">
																</b-form-group>
															</b-col>
															<b-col cols="8">
																<b-form-input size="sm" id="h-first-name" v-model="hall" name="stock_name" />
															</b-col>
														</b-row>
													</div>

												</component>
											</b-tab>
										</b-tabs>
									</div>
								</div>
							</form>
						</div>


						<div>
							<!--		<vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>-->
							<b-button class="bg-primary" style=" border-color:white;" v-on:click="addStorehouseDetail()">
								<Icon icon="material-symbols:save-outline" width="20" height="20" />{{ $t('Save') }}
							</b-button>
							<b-button class="bg-danger" style=" border-color:white;" v-on:click="initValues">
								<Icon icon="material-symbols:cancel-outline" width="20" height="20" />{{ $t('Cancel') }}
							</b-button>

						</div>


					</vs-card>
				</b-col>
				<b-col>
					<vs-card>
						<ag-grid-vue ref="agGridTable" class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
							:columnDefs="storehouseDetailColumns" :defaultColDef="defaultColDef" :rowData="storehouseDetailList"
							rowSelection="multiple" colResizeDefault="shift" :animateRows="true" :pagination="true"
							@grid-ready="onGridReady" :suppressCopyRowsToClipboard="true" :suppressPaginationPanel="true"
							:localeText="localeText">
						</ag-grid-vue>

					</vs-card>
				</b-col>
			</b-row>
		</div>
	</vs-popup>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import i18nData from "../../i18n/i18nData"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { Validator } from "vee-validate";
import moment from "moment";
import { uuid } from "vue-uuid";
import { Icon } from "@iconify/vue2";
import vSelect from "vue-select";
import DeleteWarning from "../../components/warning-message/DeleteWarning.vue";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import updateDeleteBtnCellRenderer from "../CellRenderers/updateDeleteBtnCellRenderer.vue";
export default {
	props: {
		isPromptActiveStorehouseDetail: {
			type: Boolean,
			required: true
		},
		data: {
			default: () => { }
		}
	},
	components: { updateDeleteBtnCellRenderer, AgGridVue, VuePerfectScrollbar, DeleteWarning, Icon, "v-select": vSelect },
	watch: {
		isPromptActiveStorehouseDetail(val) {
			this.tabIndex = 0
			this.getStorehouseDetail(this.data.DepotId)
			return val
		}
	},
	created() {
		this.locale = this.$i18n.locale == 'en' ? 'en-US' : this.$i18n.locale;
		const dict = {
			custom: {
				storeHosueNo: {
					required: this.$t('storeHosueNoRequired'),
					alpha: this.$t('storeHosueNoRequired')
				},
				storehosueName: {
					required: this.$t('storehosueNameRequired'),
					alpha: this.$t('storehosueNameRequired')
				},

			}
		};
		Validator.localize("en", dict);
	},
	data() {
		return {
			isMobile: function () {
				return isMobile;
			},
			storehouseDetailColumns: [],
			defaultColDef: {
				sortable: true,
				editable: true,
				resizable: true
			},
			tabIndex: 0,
			settings: { // perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: .60
			},
			storehouseDetailList: [],
			timelineData: [],
			weekday: 1,
			locale: "",
			updatedItem: [],
			deleteWarningPromptValid2: false,
			storeHosueId: "",
			storeHosueNo: "",
			storehosueName: "",
			groupCode: "",
			specCode1: "",
			specCode2: "",
			disdance: 0,
			floor: "",
			hall: "",
			preference: 0,
			status: 0,
			note: "",
			cancelDate: "",
			description: "",
			myProperty: 0,
			depotId: "",
			status_choices: [{
				text: this.$t('Active'), value: 1
			}, {
				text: this.$t('Passive'), value: 0
			}],
		}
	},
	methods: {
		onGridReady(params) {
			this.gridApi = params.api;
			this.gridColumnApi = params.columnApi;
		},
		editStorehouseDetail(item) {
			this.setDataValues(item);
		},

		deleteStorehouseDetail(data) {
			const vs = this.$vs;
			this.$store
				.dispatch("storehouse/deleteStorehouseDetail", data.StoreHosueId)
				.then(response => {
					if (response.status == 200) {
						try {
							vs.notify({
								text: response.data.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center"
							});
							this.getStorehouseDetail(this.data.DepotId);
						} catch (error) {
							console.log(error);
						}
					} else
						vs.notify({
							text: response.data.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
				})
				.catch(error => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});

		},
		parseDate(params) {
			return moment(String(params)).format("DD.MM.YYYY");
		},
		getStorehouseDetail(item) {
			const vs = this.$vs;
			this.timelineData = []
			this.storehouseDetailList = []
			this.storehouseDetailColumns = []
			this.$store.dispatch("storehouse/listStorehouseDetailForStorehouse", item).then(response => {
				// let costumerList = JSON.parse(response.json);
				if (response.success == true) {
					this.storehouseDetailList = this.$store.state.storehouse.StorehouseDetailsForStorehouse;

					let columnList = Object.keys(this.storehouseDetailList[0]);
					this.storehouseDetailColumns.push({
						width: 100,
						pinned: "left",
						cellRendererFramework: "updateDeleteBtnCellRenderer",
						cellRendererParams: {
							addMethods: "addBarcodePopup",
							addIcon: "ph:barcode"
						}
					},)
					columnList.forEach((val, index) => {
						if (val.toString().includes("Date") == true) {
							this.storehouseDetailColumns.push({ cellRendererFramework: "TextViewCellRenderer", headerName: this.$t(val), field: val, filter: "agSetColumnFilter", valueFormatter: params => this.parseDate(params.data[val]) });
						} else if (val.toString().includes("Id") == true) {
						}
						else
							this.storehouseDetailColumns.push({ cellRendererFramework: "TextViewCellRenderer", headerName: this.$t(val), field: val, filter: "agSetColumnFilter" });


					});
				} else
					console.log(response.statusText)
				/*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
			});
		},
		addStorehouseDetail() {
			var createdId = uuid.v4();
			const vs = this.$vs;
			this.$validator.validateAll().then(result => {
				if (result) {
					// if form have no errors
					const obj = {
						"storeHosueId": this.storeHosueId != "" ? this.storeHosueId : createdId,
						"storeHosueNo": this.storeHosueNo,
						"storehosueName": this.storehosueName,
						"groupCode": this.groupCode,
						"specCode1": this.specCode1,
						"specCode2": this.specCode2,
						"disdance": this.disdance == "" ? 0 : this.disdance,
						"floor": this.floor,
						"hall": this.hall,
						"preference": this.preference == "" ? 0 : this.preference,
						"status": typeof this.status.value == "undefined" || this.status == "" ? 1 : this.status.value,
						"note": this.note,
						"cancelDate": this.cancelDate == "" ? null : this.cancelDate,
						"description": this.description,
						"myProperty": this.myProperty == "" ? 0 : this.myProperty,
						"depotId": this.data.DepotId
					}

					if (this.storeHosueId != "") {

						this.$store.dispatch('storehouse/updateStorehouseDetail', obj).then(response => {
							if (response.status == 200) {
								vs.notify({
									text: response.data.message,
									iconPack: "feather",
									icon: "icon-alert-circle",
									color: "success",
									position: "top-center"
								});
								this.getStorehouseDetail(this.data.DepotId);
								this.$emit('closeSidebar')
								this.initValues()
							} else {
								vs.notify({
									text: response.data.message.toString(),
									iconPack: "feather",
									icon: "icon-alert-circle",
									color: "danger",
									position: "top-center",
								});
							}
						})
							.catch(error => {
								return new Promise((resolve, reject) => {
									resolve(false);
								});
							});
					} else {
						delete obj.id
						obj.popularity = 0
						this.$store.dispatch('storehouse/addStorehouseDetail', obj).then(response => {
							if (response.status == 200) {
								vs.notify({
									text: response.data.message,
									iconPack: "feather",
									icon: "icon-alert-circle",
									color: "success",
									position: "top-center"
								});
								this.getStorehouseDetail(this.data.DepotId);

								this.$emit('closeSidebar')
								this.initValues()
							} else {
								vs.notify({
									text: response.data.message.toString(),
									iconPack: "feather",
									icon: "icon-alert-circle",
									color: "danger",
									position: "top-center",
								});
							}
						})
							.catch(error => {
								return new Promise((resolve, reject) => {
									resolve(false);
								});
							});
					}
				} else {
					vs.notify({
						text: this.$t('Validate'),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "warning",
						position: "top-center"
					});
				}
			})

		},

		setDataValues(item) {
			this.storeHosueId = item.StoreHosueId;
			this.storeHosueNo = item.StoreHosueNo;
			this.storehosueName = item.StorehosueName;
			this.groupCode = item.GroupCode;
			this.specCode1 = item.SpecCode1;
			this.specCode2 = item.SpecCode2;
			this.disdance = item.Disdance;
			this.floor = item.Floor;
			this.hall = item.Hall;
			this.preference = item.Preference;
			this.status = { text: item.status == 0 ? this.$t('Passive') : this.$t('Active'), value: item.status };
			this.note = item.Note;
			this.cancelDate = item.CancelDate;
			this.description = item.Description;
			this.myProperty = item.MyProperty;
			this.depotId = item.DepotId;


		},
		initValues() {
			this.storeHosueId = "";
			this.storeHosueNo = "";
			this.storehosueName = "";
			this.groupCode = "";
			this.specCode1 = "";
			this.specCode2 = "";
			this.disdance = "";
			this.floor = "";
			this.hall = ""
			this.preference = "";
			this.status = "";
			this.note = ""
			this.cancelDate = "";
			this.description = "";
			this.myProperty = "";
			this.depotId = "";

		},
		clearFields() {
			this.storehouseDetailList = []
			this.$root.$emit("closeInfoDataStorehouse");
			this.storeHosueId = "";
			this.storeHosueNo = "";
			this.storehosueName = "";
			this.groupCode = "";
			this.specCode1 = "";
			this.specCode2 = "";
			this.disdance = "";
			this.floor = "";
			this.hall = ""
			this.preference = "";
			this.status = "";
			this.note = ""
			this.cancelDate = "";
			this.description = "";
			this.myProperty = "";
			this.depotId = "";
		},
	},
	mounted() {

		this.$root.$on("deleteData2", (data) => {
			this.deleteData2 = data
			this.deleteCustomer(data);
		});
		this.$root.$on("editDataBtn", (data) => {
			this.editStorehouseDetail(data);
		});
		this.$root.$on("deleteDataBtn", (data) => {
			this.deleteStorehouseDetail(data);
		});
	},
	beforeDestroy() {
		this.$root.$off("deleteData2");
		this.$root.$off("editDataBtn");
		this.$root.$off("deleteDataBtn");
	},
	computed: {
		localeText() {
			return i18nData[this.$i18n.locale];
		},
		scrollbarTag() { return this.$store.getters.scrollbarTag },
		isSidebarActiveLocal: {
			get() {
				return this.isPromptActiveStorehouseDetail
			},
			set(val) {
				if (!val) {
					this.$emit('closeSidebar')
					// this.$validator.reset()
					// this.initValues()
				}
			}
		},
	}
}
</script>
<style lang="scss" scoped>
.scroll-area--data-list-add-new-mobile {
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 450px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

.scroll-area--data-list-add-new {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 190px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

.vs-input--label {
	color: black;
	font-size: small;
}

.scroll-to-ag-grid-table {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 150px);

	&:not(.ps) {
		overflow-y: auto;
	}
}
</style>